import React, { Component } from "react"
import "./index.scss"
import DataChart from "./containers/DataChart"
import DataTable from "./containers/DataTable"
import overviewIcon from "app/styles/images/sp/overview-selected.svg"
import { observer, Provider } from "mobx-react"
import Store from "app/stores/pgs/dashboard"

@observer
export default class Index extends Component {
  constructor(props){
  	super(props)
    this.store = new Store()
  }

  render() {
    return (
      <Provider store={this.store}>
        <div className="pgs">
          <h2 className="page-title"><img alt="" src={overviewIcon} />总览</h2>
          <DataChart />
          <DataTable />
        </div>
      </Provider>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/pgs/dashboard/index.js